export default __webpack_public_path__ + "static/media/gallery-1.d2cef070.jpg";